import { useEffect, useState } from "react";

import {
  lastSignOutWasForced as checkLastSignOutWasForced,
  clearForcedSignOut
} from "features/app/redirect-on-auth-state-changed/forcedSignOut";

export default function useLastSignOutWasForced() {
  const [lastSignOutWasForced, setLastSignOutWasForced] = useState(false);

  useEffect(() => {
    const wasForced = checkLastSignOutWasForced();
    if (wasForced) setLastSignOutWasForced(true);
  }, []);

  useEffect(() => {
    return () => {
      if (lastSignOutWasForced) clearForcedSignOut();
    };
  }, [lastSignOutWasForced]);

  return lastSignOutWasForced;
}
